
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bestpostagemeters/privacy-policy",
      function () {
        return require("private-next-pages/bestpostagemeters/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bestpostagemeters/privacy-policy"])
      });
    }
  